<template>
<div class="animated fadeIn">

  <div class="row">
    <div class="col-12">
      <b-card>
        <v-server-table :columns="columns" url="/admin/reservations?status=HOLD,PAID" :options="options" :theme="theme" id="dataTable" ref="dataTable">
          <template slot="child_row" slot-scope="data">
            <b-row>
              <b-col lg="6">
                <b-table :items="data.row.members" :fields="fields" striped></b-table>
              </b-col>
              <b-col lg="6">
                <b-card title="Comments">{{ data.row.comments }}</b-card>
              </b-col>
            </b-row>
          </template>
          <template slot="id_card_no" slot-scope="data">
            {{ data.row.id_card_no ? data.row.id_card_no : translateReason(data.row.id_card_reason) }}
          </template>
          <template slot="created_at" slot-scope="data">
            {{ $moment(data.row.created_at).format('YYYY-MM-DD') }}
          </template>
          <template slot="actions" slot-scope="data">
            <b-button v-if="data.row.status == 'HOLD'" size="sm" class="mr-1" variant="outline-primary" @click="showPayment(data.row)">Bhent</b-button>
          </template>
        </v-server-table>
      </b-card>
    </div><!--/.col-->
  </div><!--/.row-->

  <div>
    <b-modal ref="modalPayment" title="Reservation Payment" hide-footer @hide="hidePayment" size="lg">
      <payment-form v-if="selectedReservation" :reservation="selectedReservation" @success="completePayment" />
    </b-modal>
  </div>

</div>

</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import PaymentForm from './PaymentForm'

export default {
  name: 'ReservationsPayment',
  components: {
    PaymentForm
  },
  data: function() {
    return {
      selectedReservation: null,
      fields: ['name', 'age', 'i_card_number'],
      columns: [
        'event_type.name',
        'id_card_no',
        'applicant_name',
        'members.length',
        'created_at',
        'arrival_date',
        'departure_date',
        'count_assigned_rooms',
        'status',
        'actions'
      ],
      options: {
        headings: {
          'event_type.name': 'Bhandara/Satsang',
          id_card_no: 'Id Card (or reason)',
          applicant_name: 'Applicant',
          'members.length': 'Members',
          arrival_date: 'Arrival',
          departure_date: 'Departure',
          count_assigned_rooms: 'Rooms',
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
        responseAdapter: function(response) {
          var data = this.getResponseData(response);
          return {
            data: data.data,
            count: data.meta.pagination.total
          }
        }
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    }
  },
  methods: {
    showPayment(reservation) {
      this.selectedReservation = reservation
      this.$refs.modalPayment.show()
    },
    hidePayment() {
      this.selectedReservation = null
      this.$refs.modalPayment.hide()
    },
    completePayment() {
      this.$refs.modalPayment.hide()
      this.$refs.dataTable.refresh()
    },
    processPayment(reservation) {
      this.$refs.modalRoomMatching.hide()
      this.selectedReservation = reservation
      this.$refs.modalPayment.show()
    },
    translateReason(reason) {
      switch (reason) {
        case 'NEW_TO_SATSANG':
          return 'New to Satsang'
        case 'SUPPORT_ELDER_PERSON':
          return 'Support to elder person'
        case 'CHILD':
          return 'Child'
      }
      return ''
    }
  },
}
</script>
